/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from 'styled-components';
import { Row, Col, Button } from 'react-bootstrap';
import { TfiSearch } from 'react-icons/tfi';
import { SearchIcon } from '@heroicons/react/solid';
import Image from 'react-bootstrap/Image';
import ListGroup from 'react-bootstrap/ListGroup';

export const BatchStyle = styled.h5`
  margin-right: 20px;
  font-size: 30px;
  font-style: bold;
  padding-left: 10px;
  padding-right: 10px;
  display: inline-block;
`;

export const VerifyButton = styled(Button)`
min-width:13vw;
max-width:13vw;
@media (max-width: 1301px) {
  min-width:19vw;
  max-width:19vw;
}
@media (max-width: 885px) {
  min-width:25vw;
  max-width:25vw;
}
@media (max-width: 631px) {
  min-width:35vw;
  max-width:35vw;
}
`;
export const descriptionStyle = styled.div`
  margin-top: 20px;
`;
export const descriptionTextStyle = styled.div`
  font-size: 20px;
`;
// export const topNavStyle = styled.div`
//   overflow: hidden;
// `;
// export const navStyle = styled.div`
//   color: red;
//   border-bottom: 3px solid transparent;
//   &:hover {
//     border-bottom: 3px solid red;
//   }

// `;
export const profileContainerStyle = styled(Col)`
  margin-top: 25px;
  padding-left: 45px;
  display: flex;
`;

export const CheckWrap = styled.div`
  flex: 0.9;
`;

export const ContainerStyle = styled(Row)`
  margin-left: 50px;
`;
export const SRow = styled(Row)`
  background-color: white;
  border-radius: 10px;
  // background-image: linear-gradient(to right,white,white, blue);
  // transform: rotateY(-180deg);
`;
export const SCol = styled(Col)`
  // background-image:u
  // background: url('https://i.ibb.co/CbVc1f2/Ministry-New-Logo-cropped-PNG-1.png');
  // background-size: cover;
`;
export const ProfileDesc = styled.p`
  font-family: 'Roboto', 'Arial', sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  color: #606060;
`;
// export const SearchContainer = styled.div`
//   position: relative;

// `;
export const SearchInput = styled.input`
  display: ${(props) => (props.show ? 'inline-block' : 'none')};
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #000;
  padding: 5px;
  color: #000;
  margin-left: 10px;
`;
export const CustomIcon = styled.p`
  font-size: 24px;
  margin-left: 20px;
  display: inline;
  font-weight: 200;
`;
export const horizontal = styled.div`
  border-top: 1px solid #d8d8d8;
  margin: 0;
`;

export const searchContainer = styled.a`
  padding: 0 32px;
  @media (max-width: 414px) {
    padding: 0;
  }
`;
export const searchIcon = styled(SearchIcon)`
  margin-top: 10px;
  margin-left: 60px;
`;

export const navLink = styled.div`
  padding: 0 32px;
  @media (max-width: 414px) {
    margin-left: 0;
    padding: 0;
    padding: 3px;
  }
  color:#606060 &:hover {
    color: black;
  }
`;
export const Meta = styled.p`
  family: 'Roboto', 'Arial', sans-serif;
  font-size: 0.8rem;
  line-height: 1.8rem;
  font-weight: 400;
  color: #606060;
`;
export const profile = styled.img`
  // width: 60%;
  // height: 90%;
  width: 4rem;
  height: 5rem;

  // margin-left: 2%;
  // margin-top: 3%;
  // border:4px solid blue;
  // @media (max-width: 414px) {
  //   padding-top: 30px;
  //   width: 60%;
  //   height: 20%;
  //   display: flex;
  //   justify-content: center;
  //   margin: auto;
  // }
  // @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  //   margin-top: 5%;
  // }
`;
export const Name = styled.h2`
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0;
  display: inline;
  @media (max-width: 414px) {
    text-align: center;
    font-size: 1rem;
    // font-weight: 400;
    // line-height: 2 rem;
    // margin-left: 100px;
  }
`;
export const profileTag = styled.span`
  width: 10%;
  height: 3%;
  margin-left: 3%;
  margin-top: 3%;
  margin-right: 1%;
  @media (max-width: 414px) {
    width: 50%;
    height: 20%;
    display: flex;
    justify-content: center;
    margin: auto;
  }
`;
export const anchor = styled.a`
  &:active {
    border-bottom: 3px solid black;
  }
  color: #d8d8d8;
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  &:hover {
    color: black;
  }
`;

export const DescriptionText = styled.p`
  font-size: 0.5rem;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;

  // margin-top: 10px;
`;

export const Icon = styled.div`
  background-color: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  align-items: center;
  justify-content: center;
  display: flex;
  margin-right: 10px;
`;

export const BadgeStyle: any = styled.span`
  background-color: ${(props: any) => props?.badgeBg};
  color: ${(props: any) => props?.badgeColor};
  display: inline;
  border-radius: 5px;
  //padding: 2px;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 3px;
  // padding-bottom: 3px;
  font-size: 12px;
`;
export const ButtonContainer = styled.div`
  margin-right: 10px;
`;

export const IconImage: any = styled(Image)`
  width: 30px;
  height: 30px;
`;

export const ListIconContainer: any = styled(ListGroup.Item)`
  display: flex;
  // align-items: baseline;
  // border:1px solid black;
  background-color: transparent;
`;

export const SubTitle = styled.h5`
  word-break: break-word;
  font-size: 12px;
`;

export const ListTitle = styled.h4`
  font-weight: bold;
  font-size: 14px;
`;

export const ListCol = styled(Col)`
  width: 250px;
  // border:2px solid black;
`;
export const ContentStyle = styled(Col)`
   width:50%;
   margin-top:5;
   margin: 2px 0;
   @media (max-width: 414px) {
    width:80%
    align-center:center;
    justify-content:center;
  }
`;
